import { gql } from '@/__generated__';

export const broadcastCustomersDocument = gql(/* GraphQL */ `
  query BroadcastCustomers(
    $where: CustomerWhereInput!
    $skip: Int!
    $take: Int!
    $orderBy: [CustomerOrderByWithRelationInput!]
  ) {
    customers(where: $where, skip: $skip, take: $take, orderBy: $orderBy) {
      id
      name
      avatar
      active
      reason
      createdAt
      updatedAt
    }
    countCustomers(where: $where)
  }
`);

export const sendBroadcastDocument = gql(/* GraphQL */ `
  mutation SendBroadcast(
    $message: String!
    $url: String!
    $where: CustomerWhereInput!
    $orderBy: [CustomerOrderByWithRelationInput!]
    $limit: Int!
    $skip: Int!
  ) {
    sendBroadcast(
      message: $message
      url: $url
      where: $where
      orderBy: $orderBy
      limit: $limit
      skip: $skip
    )
  }
`);
